"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beZones = exports.beSubZoneNameMapping = void 0;
var beZones = exports.beZones = [{
  id: 'ANTWERP',
  name: 'Anvers',
  country: 'BE',
  deliveryFee: 6,
  cornerNW: {
    latitude: 51.3773,
    longitude: 4.2487
  },
  cornerSE: {
    latitude: 51.1241,
    longitude: 4.4974
  },
  subZones: [{
    name: 'Anvers',
    zipcodes: {
      2000: {
        label: 'Antwerpen Centrum'
      },
      2018: {
        label: 'Antwerpen Zuid'
      },
      2020: {
        label: 'Antwerpen Kiel'
      },
      2030: {
        label: 'Antwerpen Luchtbal'
      },
      2040: {
        label: 'Antwerpen Berendrecht-Zandvliet-Lillo'
      },
      2050: {
        label: 'Antwerpen Linkeroever'
      },
      2060: {
        label: 'Antwerpen Noord'
      },
      2100: {
        label: 'Antwerpen Deurne'
      },
      2140: {
        label: 'Antwerpen Borgerhout'
      },
      2170: {
        label: 'Antwerpen Merksem'
      }
    }
  }]
}, {
  id: 'BRUGES',
  name: 'Bruges',
  country: 'BE',
  deliveryFee: 6,
  cornerNW: {
    latitude: 51.2359,
    longitude: 3.1902
  },
  cornerSE: {
    latitude: 51.1827,
    longitude: 3.2684
  },
  subZones: [{
    name: 'Bruges',
    zipcodes: {
      8000: {
        label: 'Brugge Centrum'
      },
      8200: {
        label: 'Sint-Andries'
      },
      8310: {
        label: 'Sint-Kruis'
      },
      8380: {
        label: 'Dudzele'
      }
    }
  }]
}, {
  id: 'BRUXELLES',
  name: 'Bruxelles',
  country: 'BE',
  deliveryFee: 6,
  cornerNW: {
    latitude: 50.8996,
    longitude: 4.3407
  },
  cornerSE: {
    latitude: 50.7967,
    longitude: 4.4536
  },
  subZones: [{
    name: 'Bruxelles-Ville',
    zipcodes: {
      1000: {
        label: '1000'
      },
      1020: {
        label: '1020'
      },
      1120: {
        label: '1120'
      },
      1130: {
        label: '1130'
      }
    }
  }, {
    name: 'Anderlecht',
    zipcodes: {
      1070: {
        label: '1070'
      }
    }
  }, {
    name: 'Auderghem',
    zipcodes: {
      1160: {
        label: '1160'
      }
    }
  }, {
    name: 'Berchem-Sainte-Agathe',
    zipcodes: {
      1082: {
        label: '1082'
      }
    }
  }, {
    name: 'Etterbeek',
    zipcodes: {
      1040: {
        label: '1040'
      }
    }
  }, {
    name: 'Evere',
    zipcodes: {
      1140: {
        label: '1140'
      }
    }
  }, {
    name: 'Forest',
    zipcodes: {
      1190: {
        label: '1190'
      }
    }
  }, {
    name: 'Ganshoren',
    zipcodes: {
      1083: {
        label: '1083'
      }
    }
  }, {
    name: 'Ixelles',
    zipcodes: {
      1050: {
        label: '1050'
      }
    }
  }, {
    name: 'Jette',
    zipcodes: {
      1090: {
        label: '1090'
      }
    }
  }, {
    name: 'Koekelberg',
    zipcodes: {
      1081: {
        label: '1081'
      }
    }
  }, {
    name: 'Molenbeek-Saint-Jean',
    zipcodes: {
      1080: {
        label: '1080'
      }
    }
  }, {
    name: 'Saint-Gilles',
    zipcodes: {
      1060: {
        label: '1060'
      }
    }
  }, {
    name: 'Saint-Josse-ten-Noode',
    zipcodes: {
      1210: {
        label: '1210'
      }
    }
  }, {
    name: 'Schaerbeek',
    zipcodes: {
      1030: {
        label: '1030'
      }
    }
  }, {
    name: 'Uccle',
    zipcodes: {
      1180: {
        label: '1180'
      }
    }
  }, {
    name: 'Watermael-Boitsfort',
    zipcodes: {
      1170: {
        label: '1170'
      }
    }
  }, {
    name: 'Woluwe-Saint-Lambert',
    zipcodes: {
      1200: {
        label: '1200'
      }
    }
  }, {
    name: 'Woluwe-Saint-Pierre',
    zipcodes: {
      1150: {
        label: '1150'
      }
    }
  }]
}, {
  id: 'CHARLEROI',
  name: 'Charleroi',
  country: 'BE',
  deliveryFee: 6,
  cornerNW: {
    latitude: 50.4527,
    longitude: 4.4119
  },
  cornerSE: {
    latitude: 50.3894,
    longitude: 4.4897
  },
  subZones: [{
    name: 'Charleroi',
    zipcodes: {
      6000: {
        label: 'Charleroi-Centre'
      },
      6020: {
        label: 'Dampremy'
      },
      6030: {
        label: 'Marchienne-au-Pont'
      },
      6040: {
        label: 'Jumet'
      },
      6060: {
        label: 'Gilly'
      }
    }
  }]
}, {
  id: 'GHENT',
  name: 'Gand',
  country: 'BE',
  deliveryFee: 6,
  cornerNW: {
    latitude: 51.0897,
    longitude: 3.6668
  },
  cornerSE: {
    latitude: 51.0261,
    longitude: 3.7697
  },
  subZones: [{
    name: 'Gand',
    zipcodes: {
      9000: {
        label: 'Gent-Centrum'
      },
      9030: {
        label: 'Mariakerke'
      },
      9040: {
        label: 'Sint-Amandsberg'
      },
      9050: {
        label: 'Gentbrugge'
      },
      9052: {
        label: 'Zwijnaarde'
      }
    }
  }]
}, {
  id: 'KORTRIJK',
  name: 'Courtrai',
  country: 'BE',
  deliveryFee: 6,
  cornerNW: {
    latitude: 50.8497,
    longitude: 3.2119
  },
  cornerSE: {
    latitude: 50.7894,
    longitude: 3.2897
  },
  subZones: [{
    name: 'Courtrai',
    zipcodes: {
      8500: {
        label: 'Kortrijk Centrum'
      },
      8501: {
        label: 'Heule'
      },
      8510: {
        label: 'Marke'
      },
      8511: {
        label: 'Aalbeke'
      },
      8520: {
        label: 'Kuurne'
      }
    }
  }]
}, {
  id: 'LIEGE',
  name: 'Liège',
  country: 'BE',
  deliveryFee: 6,
  cornerNW: {
    latitude: 50.6798,
    longitude: 5.5419
  },
  cornerSE: {
    latitude: 50.6105,
    longitude: 5.6397
  },
  subZones: [{
    name: 'Liège',
    zipcodes: {
      4000: {
        label: 'Liège-Centre'
      },
      4020: {
        label: 'Liège-Droixhe'
      },
      4030: {
        label: 'Grivegnée'
      },
      4031: {
        label: 'Angleur'
      },
      4032: {
        label: 'Chênée'
      }
    }
  }]
}, {
  id: 'LOUVAIN',
  name: 'Louvain',
  country: 'BE',
  deliveryFee: 6,
  cornerNW: {
    latitude: 50.8897,
    longitude: 4.6668
  },
  cornerSE: {
    latitude: 50.8261,
    longitude: 4.7697
  },
  subZones: [{
    name: 'Louvain',
    zipcodes: {
      3000: {
        label: 'Leuven Centrum'
      },
      3001: {
        label: 'Heverlee'
      },
      3010: {
        label: 'Kessel-Lo'
      },
      3012: {
        label: 'Wilsele'
      },
      3018: {
        label: 'Wijgmaal'
      }
    }
  }]
}, {
  id: 'MONS',
  name: 'Mons',
  country: 'BE',
  deliveryFee: 6,
  cornerNW: {
    latitude: 50.4727,
    longitude: 3.9119
  },
  cornerSE: {
    latitude: 50.4094,
    longitude: 3.9897
  },
  subZones: [{
    name: 'Mons',
    zipcodes: {
      7000: {
        label: 'Mons Centre'
      },
      7010: {
        label: 'Flénu'
      },
      7012: {
        label: 'Jemappes'
      },
      7020: {
        label: 'Nimy'
      },
      7024: {
        label: 'Ciply'
      }
    }
  }]
}, {
  id: 'NAMUR',
  name: 'Namur',
  country: 'BE',
  deliveryFee: 6,
  cornerNW: {
    latitude: 50.4897,
    longitude: 4.8119
  },
  cornerSE: {
    latitude: 50.4394,
    longitude: 4.8897
  },
  subZones: [{
    name: 'Namur',
    zipcodes: {
      5000: {
        label: 'Namur Centre'
      },
      5001: {
        label: 'Belgrade'
      },
      5002: {
        label: 'Saint-Servais'
      },
      5003: {
        label: 'Saint-Marc'
      },
      5004: {
        label: 'Bouge'
      }
    }
  }]
}];
var beSubZoneNameMapping = exports.beSubZoneNameMapping = [{
  old: 'Bruxelles Laeken',
  "new": 'Bruxelles-Ville'
}, {
  old: 'Bruxelles Schaerbeek',
  "new": 'Schaerbeek'
}, {
  old: 'Bruxelles Forest',
  "new": 'Forest'
}];